export default __webpack_public_path__ + "static/media/E0A564AC-B4FC-48BD-971B-4EBD81E5D462_1_105_c.f2b175f9.jpeg";